import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Header from 'modules/common/Header';
import { setTabs } from 'modules/common/Tabs/actions';
import TripsTabContainer from '../TripsTabContainer';
import TripContainer from '../TripContainer';
import { tabs } from './constants';
import ReportsContainer from '../ReportsContainer';
import AttentionMsg from '../AttentionMsg';

export const Security: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTabs(tabs));
  }, []);

  return (
    <React.Fragment>
      <AttentionMsg />
      <Header />
      <Switch>
        <Route path="/security" exact render={(props) => <TripsTabContainer {...props} lolomode={1} />} />
        <Route path="/security/unload" exact render={(props) => <TripsTabContainer {...props} lolomode={2} />} />
        <Route path="/security/reports" component={ReportsContainer} />
        <Route path="/security/trip/:tripId" component={TripContainer} />
      </Switch>
    </React.Fragment>
  );
};
